import {
  Component,
  HostBinding,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss'],
})
export class RecoverPasswordComponent implements OnInit, OnDestroy {
  public recoverPassForm: FormGroup;
  public isAuthLoading = false;
  public env = environment.forntend_url;

  constructor(public formBuilder: FormBuilder, public router: Router) {}

  ngOnInit(): void {
    this.recoverPassForm = this.formBuilder.group({
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    });
  }

  ngOnDestroy(): void {}

  get formData() {
    return this.recoverPassForm.controls;
  }

  submit() {
    this.router.navigate(['/']);
  }
}
